import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ChangedArea, type EventRevisionDto } from "../../../../autogen/bff-api";
import { ChangedAreaTags } from "./ChangedAreaTags";

interface Props {
  revision: EventRevisionDto;
}

const formatInstant = (iso: string): string =>
  new Date(iso).toLocaleString("nb-NO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Oslo",
  });

export const ChangeLogEntry = ({ revision }: Props) => {
  const { t } = useTranslation();
  const changedTerm = revision.dpsValidTo
    ? { label: t("New end of validity"), at: revision.dpsValidTo, area: ChangedArea.DpsValidity }
    : revision.bidSubmissionDeadline
      ? { label: t("Bid deadline"), at: revision.bidSubmissionDeadline, area: ChangedArea.Deadline }
      : null;

  return (
    <>
      <Text fontSize="xs" color="smMuted">
        {revision.publishedAt ? formatInstant(revision.publishedAt) : ""}
      </Text>
      <Text fontSize="sm" fontWeight="medium" mt="1">
        {revision.changeDescription}
      </Text>
      <ChangedAreaTags revision={revision} omit={changedTerm ? [changedTerm.area] : []} />
      {changedTerm && (
        <Text fontSize="sm" color="smMuted" mt="1">
          {changedTerm.label}: {formatInstant(changedTerm.at)}
        </Text>
      )}
    </>
  );
};
